/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is RCF or g-force?`)
};

const es_gf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es la RCF o fuerza g?`)
};

const de_gf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist RCF bzw. G-Kraft?`)
};

const nl_gf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is RCF of g-kracht?`)
};

const fr_gf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que la RCF ou force g ?`)
};

const it_gf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è l'RCF o forza G?`)
};

const pt_br2_gf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é RCF ou força g?`)
};

const pt_gf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é a RCF ou força g?`)
};

const ja_gf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF(g力)とは何ですか?`)
};

const zh_gf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是 RCF 或离心力？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_faq_q1", locale)
	if (locale === "en") return en_gf_faq_q1(inputs)
	if (locale === "es") return es_gf_faq_q1(inputs)
	if (locale === "de") return de_gf_faq_q1(inputs)
	if (locale === "nl") return nl_gf_faq_q1(inputs)
	if (locale === "fr") return fr_gf_faq_q1(inputs)
	if (locale === "it") return it_gf_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_gf_faq_q1(inputs)
	if (locale === "pt") return pt_gf_faq_q1(inputs)
	if (locale === "ja") return ja_gf_faq_q1(inputs)
	return zh_gf_faq_q1(inputs)
};